<script>
  import { getContext } from 'svelte';
  const { width } = getContext('LayerCake');
</script>

<rect x="0" y="15" width="{$width}" height="0.5" class="container"></rect>

<style>
  rect.container {
    fill: #fafafa;
    stroke:#222;
  }
</style>